import { Collapse, Row, Col, Tag } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  ModalItem,
  ButtonItem,
} from "../../../../Components/Items";
import moment from "moment";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import EnviarCorreoEntregarInsumosVenta from "../EntregarInsumosVenta/EnviarCorreoEntregarInsumosVenta/EnviarCorreoEntregarInsumosVenta";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Panel } = Collapse;

class EntregasVenta extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    entregasHtml: <p>No se encontró ninguna entrega</p>,
    modalVerEntrega: false,
    modalVerEntregaId: null,
    entregaSeleccionada: null,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible)
      this.consultarTodo();
  }

  consultarTodo() {
    this.setState({ loading: true });

    axios
      .post(
        "ventas/entregasVenta",
        { ventaId: this.props.id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        const entregas = res.data?.entregas || [];
        const insumosCatalogo = res.data?.insumos || []; // Nuevo: insumos del catálogo

        if (!entregas.length) {
          this.setState({
            entregasHtml: <p>No se encontró ninguna entrega</p>,
            loading: false,
          });
          return;
        }

        const html = (
          <Collapse style={{ marginBottom: 10 }}>
            {entregas.map((entrega) => (
              <Panel
                key={entrega._id}
                header={`Entrega del ${moment(entrega.fecha)
                  .locale("es")
                  .format("LL")}`}
                extra={
                  <Tag color="blue">
                    {`Insumos: ${
                      entrega.insumos?.filter((i) => i.cantidad > 0).length || 0
                    }`}
                  </Tag>
                }
              >
                <Row gutter={[16, 16]}>
                  <Col span={12}>
                    <p>
                      <b>Fecha:</b>{" "}
                      {moment(entrega.fecha).locale("es").format("LLLL")}
                    </p>
                  </Col>
                  <Col span={12}>
                    <p>
                      <b>Total de Insumos:</b>{" "}
                      {entrega.insumos?.filter((i) => i.cantidad > 0).length || 0}
                    </p>
                    <ButtonItem
                      type="primary"
                      onClick={async (e) => {
                        e.stopPropagation();
                        await new Promise((resolve) => {
                          this.setState({
                            modalVerEntregaId: entrega._id,
                            entregaSeleccionada: entrega,
                          }, resolve);
                        });
                        
                        this.setState({ modalVerEntrega: true });
                      }}
                    >
                      Ver Detalle
                    </ButtonItem>
                  </Col>
                </Row>

                {entrega.insumos?.length > 0 && (
                  <Collapse 
                    style={{ marginTop: 16 }} 
                    accordion
                    bordered={false}
                  >
                    {entrega.insumos
                      .filter((insumo) => insumo.cantidad > 0)
                      .map((insumoEntrega, index) => {
                        // Buscar el insumo en el catálogo usando insumoId
                        const insumoCatalogo = insumosCatalogo.find(
                          (i) => i._id === insumoEntrega.insumoId
                        );

                        // Buscar referencia en this.props.insumos si existe
                        const insumoVentaRef = this.props.insumos?.find(
                          (i) => i._id === insumoEntrega.insumoId || i.insumoId === insumoEntrega.insumoId
                        );

                        // Combinar datos
                        const insumo = {
                          ...insumoCatalogo,
                          ...insumoVentaRef,
                          cantidad: insumoEntrega.cantidad,
                          _id: insumoEntrega._id,
                        };

                        // Calcular el total
                        const precioUnitario = insumoVentaRef?.precioUnitario || insumoCatalogo?.costo || 0;
                        const total = precioUnitario * insumoEntrega.cantidad;

                        return (
                          <Panel
                            key={insumoEntrega._id || index}
                            header={insumo.descripcion || `Insumo ${index + 1}`}
                          >
                            <p><b>Clave:</b> {insumo.clave || "N/A"}</p>
                            <p><b>Código:</b> {insumo.codigo || "N/A"}</p>
                            <p><b>Unidad:</b> {insumo.unidadNombre || "N/A"}</p>
                            <p><b>Cantidad entregada:</b> {insumoEntrega.cantidad || 0}</p>
                            <p>
                              <b>Precio unitario:</b> $
                              {precioUnitario.toFixed(2)}
                            </p>
                            <p><b>Total:</b> ${total.toFixed(2)}</p>
                          </Panel>
                        );
                      })}
                  </Collapse>
                )}

              </Panel>
            ))}
          </Collapse>
        );

        this.setState({ entregasHtml: html, loading: false });
      })
      .catch((err) => {
        console.error("Error al obtener entregas:", err);
        this.setState({
          entregasHtml: <p>Error al consultar las entregas</p>,
          loading: false,
        });
      });
  }

  cerrarEntregasVenta() {
    this.props.cerrarEntregasVenta();
  }

  cerrarModalCorreo() {
    this.setState({
      modalVerEntrega: false,
      modalVerEntregaId: null,
      entregaSeleccionada: null,
    });
  }

  render() {

    return (
      <>
        <ModalItem
          title="Entregas de Venta"
          visible={this.props.visible}
          spinning={this.state.loading}
          onCancel={this.cerrarEntregasVenta.bind(this)}
          paddingTop
          zIndex={1}
        >
          {this.state.entregasHtml}
        </ModalItem>

        
          <EnviarCorreoEntregarInsumosVenta
            visible={this.state.modalVerEntrega}
            id={this.props.id}
            entregaId={this.state.modalVerEntregaId}
            cerrarMandarCorreo={this.cerrarModalCorreo.bind(this)}
            zIndex={2}
            padre={2}
          />
        
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(EntregasVenta);